import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { PlanStep } from '../../../../services/PlanStep';
import { StrtPriority } from '../../../../../shared/models/plan/StrtPriority';
import { StepComponent } from '../../../step.component';
import { PlanCoordinate } from '../../../../services/plan-coordinate';
import { APP_CONFIG, AppConfig } from '../../../../../app-config.module';
import {UiUtils} from '../../../../services/ui-utils';
import {ResourceService} from '../../../../services/resource.service';

@Component({
  selector: 'app-priority-stack-header',
  templateUrl: './priority-stack-header.component.html',
  styleUrls: ['./priority-stack-header.component.scss']
})
export class PriorityStackHeaderComponent extends StepComponent<void> implements OnInit {

  @Input() placeholderColor: string;
  @Input() pageIndex: number;
  @Input() hasFullPriorityList: boolean;
  @Output() planCoordinateChange = new EventEmitter<PlanCoordinate>();
  private _priorities: StrtPriority[];

  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig,
              _resourceService: ResourceService) {
    super(PlanCoordinate.stepBy(PlanStep.OUTPUTS), _resourceService);
  }

  @Input() set priorities(priorities: StrtPriority[]) {
    this._priorities = priorities;
  }

  get priorities() {
    return this._priorities;
  }

  ngOnInit() {}

  classShadowColorCode(colorCode: string) {
    return UiUtils.darken(colorCode, 30);
  }

  get needsPlaceholderColumn() {
    return (!this.hasFullPriorityList) &&
      this._priorities.length < this.appConfig.uiRules.deliverables.strategyMap.MAX_COLUMNS_PER_PAGE;
  }

  get needsFillerPlaceholderColumns() {
    return this._priorities.length === 0 && this.pageIndex === 0;
  }

  get needsInvisiColumn() {
    return (this._priorities.length > 0 || this.pageIndex > 0)
      && this._priorities.length < (this.appConfig.uiRules.deliverables.strategyMap.MAX_COLUMNS_PER_PAGE - 1);
  }

  get needsSecondInvisiColumn() {
    return (this._priorities.length > 0 || this.pageIndex > 0)
      && (this._priorities.length === 0 || (this._priorities.length === 1 && this.hasFullPriorityList));
  }

  get transparent() {
    return 'transparent';
  }

  public onClickPurposeMissionBeliefs() {
    this.planCoordinateChange.emit(PlanCoordinate.stepBy(PlanStep.SYNTHESIZE_RESULTS));
  }

  public onPlanCoordinateChange(planCoordinate: PlanCoordinate) {
    this.planCoordinateChange.emit(planCoordinate);
  }
}
